import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config";
import Header from "../../Header";
// import Footer from '../../Pages/Footer';
import Dashboardfooter from "../../Pages/Dashboardfooter";
import Nofees from "../../Pages/Presale/IconBox/Nofees";
import Multiswap from "../../Pages/Presale/IconBox/Multiswap";
import AccordionBox from "../../Pages/Presale/Accordion";
import Oneclickswap from "../../Pages/Presale/IconBox/Oneclickswap";
import "../../Dashboard/css/swap.css";
import {
  Container,
  Row,
  Col,
  Card,
  Nav,
  Form,
  Button,
  Tabs,
  Tab,
  Modal,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import ExchangeIcon from "../../Pages/Presale/IconBox/ExchangeIcon";
import { LiaAngleDownSolid } from "react-icons/lia";
import { IoSearch } from "react-icons/io5";
import Web3ModalProvider from "../../Pages/Presale/Connectwallet/Web3ModalProvider";
import { useDispatch, useSelector } from "react-redux";
import {
  FEE_SYMBOL,
  INFI_CONTRACT,
  INFI_DECIMAL,
  LIQUIDITY_CONTRACT,
  TOKEN_A,
  TOKEN_B,
  USDT_CONTRACT,
  USDT_DECIMAL,
} from "../../Web3/web3Config";
import {
  BloackchainExpectedReceivableAmount,
  BloackchainCheckAllowanceAndApprove,
  BloackchainGetTokenBalance,
  BloackchainGetTokenPrice,
  BloackchainSwapToken,
} from "../../Web3/SwapConnector";
import { BsFuelPump } from "react-icons/bs";
import { GoChevronDown } from "react-icons/go";
import { ClipLoader } from "react-spinners";
import { ERROR, Success, Warning } from "../../../utils/errors";

import Appsidebar from "../../Appsidebar";
import Mobileappsidebar from "../../Mobileappsidebar";

const Swap = () => {
  const [show, setShow] = useState(false);
  const _useWeb3ModalProvider = Web3ModalProvider();
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const [connectWalletNow, setConnectWalletNow] = useState(false);
  const [WalletAddress, setWalletAddress] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const isBurn = useRef(false);
  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  const [priceIs, setPriceIs] = useState(0.0);
  const [PriceInterval, setPriceInterval] = useState(0);
  const [PriceLoading, setPriceLoading] = useState(true);
  const [swapSummary, setSwapSummary] = useState({
    priceImpact: 0.0,
    fees: 0.0,
  });

  const [swapLoading, setSwapLoading] = useState(false);
  const [swapErr, setSwapErr] = useState({
    fromErrText: "",
    fromErrAmount: "",
    toErrText: "",
    toErrAmount: "",
  });

  const [tokenA, setTokenA] = useState(TOKEN_A);
  const [tokenB, setTokenB] = useState(TOKEN_B);

  const inputstyle = {
    paddingLeft: "40px",
    backgroundColor: "#85DEF51A",
    border: "1px solid #85DEF51A",
    borderRadius: "10px",
  };

  useEffect(() => {
    setWalletAddress(walletConnnected);
  }, [walletConnnected]);

  useEffect(() => {
    if (!isProviderLoaded) {
      _useWeb3ModalProvider.then((data) => {
        if (data) {
          setisProviderLoaded(true);
        }
      });
    }
  }, [_useWeb3ModalProvider]);

  useEffect(() => {
    if (isProviderLoaded) {
      BloackchainGetTokenPriceSwap();
      getWalletBalance();
      setPriceInterval(
        setInterval(() => {
          BloackchainGetTokenPriceSwap();
        }, 5000)
      );
    }
  }, [isProviderLoaded]);

  const BloackchainGetTokenPriceSwap = async (a) => {
    try {
      let request = {
        tokenName: tokenA.symbol,
        liquidityContract: LIQUIDITY_CONTRACT,
        walletProvider: _useWeb3ModalProvider,
        infiDecimal: INFI_DECIMAL,
        usdtDecimal: USDT_DECIMAL,
      };
      let tokenPrice = await BloackchainGetTokenPrice(request);
      setPriceIs(tokenPrice.price);
      setPriceLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getWalletBalance = async (a) => {
    try {
      let tokenARes = await BloackchainGetTokenBalance(
        walletConnnected,
        tokenA.contract,
        _useWeb3ModalProvider
      );
      let tokenBRes = await BloackchainGetTokenBalance(
        walletConnnected,
        tokenB.contract,
        _useWeb3ModalProvider
      );
      if (tokenARes.status) {
        setTokenA({ ...tokenA, balance: tokenARes.balance });
      } else {
        Warning(tokenARes.message);
      }
      if (tokenBRes.status) {
        setTokenB({ ...tokenB, balance: tokenBRes.balance });
      }
    } catch (error) {
      console.log("error in getWalletBalance", error);
    }
  };

  const ChangeCoins = async () => {
    setPriceLoading(true);
    clearInterval(PriceInterval);
    setTokenA(tokenB);
    setTokenB(tokenA);
    setisProviderLoaded(false);
  };

  const [amountToSwap, setAmountToSwap] = useState("");
  const [amountToReceive, setAmountToReceive] = useState("");
  useEffect(() => {
    calculateReceivableAmount(amountToSwap, 0);
  }, [tokenA, tokenB]);

  const goToLogin = async () => {
    navigate(config.baseurl + "login");
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name == "fromAmount") {
      if (!value || value == "" || value == 0) {
        setAmountToReceive("");
        // setTokenB({ ...tokenB, amount: '' })
      }
      // setTokenA({ ...tokenA, amount: value })
      setAmountToSwap(value);
      if (value > tokenA.balance) {
        setSwapErr({
          ...swapErr,
          fromErrText: "Max Amount",
          fromErrAmount: tokenA.balance + " " + tokenA.symbol,
        });
      } else if (tokenA.symbol == "USDT" && value < 1) {
        setSwapErr({
          ...swapErr,
          fromErrText: "Min Amount",
          fromErrAmount: "1 " + tokenA.symbol,
        });
      } else {
        setSwapErr({ ...swapErr, fromErrText: "", fromErrAmount: "" });
      }
      calculateReceivableAmount(value, 0);
    } else if (name == "toAmount") {
      if (!value || value == "" || value == 0) {
        setAmountToSwap("");
        // setTokenA({ ...tokenA, amount: '' })
      }
      setAmountToReceive(value);
      // setTokenB({ ...tokenB, amount: value })
      if (value > tokenB.balance) {
        setSwapErr({
          ...swapErr,
          toErrText: "Max Amount",
          toErrAmount: tokenB.balance + " " + tokenB.symbol,
        });
      } else if (tokenB.symbol == "INFI" && value < 1) {
        setSwapErr({
          ...swapErr,
          toErrText: "Min Amount",
          toErrAmount: "1 " + tokenB.symbol,
        });
      } else {
        setSwapErr({ ...swapErr, toErrText: "", toErrAmount: "" });
      }
      calculateReceivableAmount(0, value);
    }
  };

  const calculateReceivableAmount = async (AmountA, AmountB) => {
    try {
      let request = {
        liquidityContract: LIQUIDITY_CONTRACT,
        infiContract: INFI_CONTRACT,
        usdtContract: USDT_CONTRACT,
        isBurn: isBurn.current,
        walletProvider: _useWeb3ModalProvider,
        infiDecimal: INFI_DECIMAL,
        usdtDecimal: USDT_DECIMAL,
      };
      let res;
      if (AmountA > 0) {
        request.symbol = tokenA.symbol;
        request.amount = AmountA;
        res = await BloackchainExpectedReceivableAmount(request);
        console.log({ InAmountA: res });
        setAmountToReceive(res.amountToReceive);
        // setTokenB({ ...tokenB, amount: res.amountToReceive })
      } else if (AmountB > 0) {
        request.symbol = tokenB.symbol;
        request.amount = AmountB;
        res = await BloackchainExpectedReceivableAmount(request);
        console.log({ InAmountB: res });
        setAmountToSwap(res.amountToReceive);
        // setTokenA({ ...tokenA, amount: res.amountToReceive })
      }
      setSwapSummary({
        ...swapSummary,
        fees: res.totalFees,
        priceImpact: res.currentPriceImpact,
      });
    } catch (error) {

      console.log({ error });
    }
  };

  const handleIsBurn = () => {
    isBurn.current = !isBurn.current;
    calculateReceivableAmount(amountToSwap, 0);
  };

  const swapNow = async () => {
    console.log("swapping start....");
    try {
      await calculateReceivableAmount(amountToSwap, 0);
      setSwapLoading(true);

      if (swapSummary.priceImpact >= 15) {
        ERROR("Price impact is too high. Please decrese swap amount.");
        setSwapLoading(false);
        return;
      }

      // let swapAmount =
      //   tokenA.symbol == "INFI"
      //     ? amountToSwap
      //     : parseFloat(amountToSwap) + parseFloat(swapSummary.fees);
      let swapAmount = amountToSwap;
      let request = {
        walletProvider: _useWeb3ModalProvider,
        walletAddress: WalletAddress,
        contractAddress: tokenA.contract,
        amount: swapAmount,
        fromToken: tokenA.symbol,
        toToken: tokenB.symbol,
        liquidityContract: LIQUIDITY_CONTRACT,
        isBurn: isBurn.current,
      };

      if (
        WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()
      ) {
        setSwapLoading(false);
        Warning("Please connect with registered wallet");
        return;
      }

      let res = await BloackchainCheckAllowanceAndApprove(request);

      if (res.status) {
        
        // if (tokenA.symbol === "INFI") {
        //   request.amount = swapSummary.fees;
        //   request.contractAddress = tokenB.contract;
        //   res = await BloackchainCheckAllowanceAndApprove(request);
        //   request.contractAddress = tokenA.contract;
        // }

        if (res.status) {
          request.amount = swapAmount;
          
          let res = await BloackchainSwapToken(request);
          // setSwapLoading(false);
          if (res.status) {
            setAmountToSwap("");
            setAmountToReceive("");
            Success(
              "Token swapped successfully, It will take a few minutes to confirm the transaction."
            );
            getWalletBalance();
            setSwapLoading(false);

          } else {
            Warning(res.message);
            setSwapLoading(false);

          }
        }
      } else {
        setSwapLoading(false);
        Warning(res.message);
      }
    } catch (error) {
      setSwapLoading(false);
      console.log({ errorSwap : error });
      ERROR(error);

    }
  };

  return (
    <>
      <div className="dashboard">
      <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setConnectWalletNow}
      />
      {/* <Dashboardheader /> */}

      <div className="wrapper">
        <Appsidebar className="" />
        {/* <Mobileappsidebar className=""/> */}
        <div id="content" className='position-relative'>
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div>
                  <Row className="">
                    <Col lg={12}>
                      <Card className="cardBox ExchangeForm">
                        <Row>
                          <Col lg={8} md={8} sm={12} className="mb-4 mx-auto">
                            {/* <ul className="nav nav-tabs border-0" id="myTab" role="tablist">
															<li className="nav-item" role="presentation">
																<button
																	className="nav-link active"
																	id="swap-tab"
																	data-bs-toggle="tab"
																	data-bs-target="#swap"
																	type="button"
																	role="tab"
																	aria-controls="swap"
																	aria-selected="true"
																>
																	Swap
																</button>
															</li>
															<li className="nav-item" role="presentation">
																<button
																	className="nav-link"
																	id="buy-tab"
																	data-bs-toggle="tab"
																	data-bs-target="#buy"
																	type="button"
																	role="tab"
																	aria-controls="buy"
																	aria-selected="false"
																>
																	Buy
																</button>
															</li>
														</ul> */}
                            <div className="text-center">
                              <h2 className="text-primary fs-1">Swap</h2>
                            </div>
                          </Col>
                          {/* <Col lg={4} md={4} sm={12} className="mb-4 d-flex justify-content-end">
														<div>
															<Button variant="filterbtn" className='px-4 '>
																<span>
																	<img
																		src="./assets/icons/filterIcon.svg"
																		alt="filterIcon"
																		className="filterIcon me-3"
																	/>
																</span>
																Filter
															</Button>
														</div>
													</Col> */}
                        </Row>

                        <Row>
                          <Col lg={12} md={12} sm={12} className="">
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade show active"
                                id="swap"
                                role="tabpanel"
                                aria-labelledby="swap-tab"
                              >
                                <Row>
                                  <Col lg={8} className="mx-auto">
                                    <Tab.Container
                                      id="left-tabs-example"
                                      defaultActiveKey="swap"
                                    >
                                      <Row className="mt-3 ">
                                        <Col sm={12} className="swapform">
                                          <Tab.Content>
                                            <Tab.Pane eventKey="swap">
                                              <Form>
                                                {loginDetails.isLogin ? (
                                                  <>
                                                    {walletConnnected ? (
                                                      <>
                                                        <div className="d-flex d-none1 justify-content-between text-danger">
                                                          <div>
                                                            <small className="fw-bold">
                                                              {
                                                                swapErr.fromErrText
                                                              }
                                                            </small>
                                                          </div>
                                                          <div>
                                                            <small className="fw-bold">
                                                              {
                                                                swapErr.fromErrAmount
                                                              }
                                                            </small>
                                                          </div>
                                                        </div>
                                                        <div className="inputField border p-3 pb-0">
                                                          <Form.Group className="mb-3">
                                                            <div className="d-flex justify-content-between">
                                                              <div>
                                                                <Form.Label>
                                                                  Pay
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  placeholder="0"
                                                                  className=" border-0 bg-transparent p-0"
                                                                  name="fromAmount"
                                                                  // onKeyPress={(
                                                                  //   event
                                                                  // ) => {
                                                                  //   if (
                                                                  //     !/^\d*[.]?\d{0,1}$/.test(
                                                                  //       event.key
                                                                  //     )
                                                                  //   ) {
                                                                  //     event.preventDefault();
                                                                  //   }
                                                                  // }}
                                                                  onKeyPress={(
                                                                    event
                                                                  ) => {
                                                                    // Allow only digits, backspace, and decimal point
                                                                    if (
                                                                      !/^\d$/.test(
                                                                        event.key
                                                                      ) &&
                                                                      event.key !==
                                                                      "." &&
                                                                      event.key !==
                                                                      "Backspace"
                                                                    ) {
                                                                      event.preventDefault();
                                                                    }

                                                                    // Prevent entering more than four digits after the decimal point
                                                                    const {
                                                                      value,
                                                                    } =
                                                                      event.target;
                                                                    const decimalIndex =
                                                                      value.indexOf(
                                                                        "."
                                                                      );
                                                                    if (
                                                                      decimalIndex !==
                                                                      -1 &&
                                                                      value.slice(
                                                                        decimalIndex +
                                                                        1
                                                                      )
                                                                        .length >=
                                                                      4 &&
                                                                      event.key !==
                                                                      "Backspace"
                                                                    ) {
                                                                      event.preventDefault();
                                                                    }

                                                                    // Ensure only one decimal point is allowed
                                                                    if (
                                                                      event.key ===
                                                                      "." &&
                                                                      value.indexOf(
                                                                        "."
                                                                      ) !== -1
                                                                    ) {
                                                                      event.preventDefault();
                                                                    }
                                                                  }}
                                                                  value={
                                                                    amountToSwap
                                                                  }
                                                                  onInput={(
                                                                    e
                                                                  ) =>
                                                                    inputHandler(
                                                                      e
                                                                    )
                                                                  }
                                                                  autoComplete="off"
                                                                />
                                                              </div>
                                                              <div>
                                                                <Form.Label>
                                                                  Balance:{" "}
                                                                  {parseFloat(
                                                                    tokenA.balance ||
                                                                    0
                                                                  ).toFixed(2)}
                                                                </Form.Label>
                                                                <div>
                                                                  <Button
                                                                    variant="default"
                                                                    className="text-primary border-0 bg-transparent fs-5 text-uppercase currency_dropdown"
                                                                  >
                                                                    <img
                                                                      src={
                                                                        tokenA.icon
                                                                      }
                                                                      style={{
                                                                        lineHeight:
                                                                          "0",
                                                                      }}
                                                                      width="35px"
                                                                    />
                                                                    &nbsp;{" "}
                                                                    {
                                                                      tokenA.symbol
                                                                    }
                                                                    {/* <LiaAngleDownSolid /> */}
                                                                  </Button>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </Form.Group>
                                                        </div>
                                                        <div className="exchangeIcon mt-3 mb-3 text-center">
                                                          <Button
                                                            variant="default"
                                                            className=""
                                                            onClick={() =>
                                                              ChangeCoins()
                                                            }
                                                          >
                                                            <ExchangeIcon className="refresh_ico" />
                                                          </Button>
                                                        </div>
                                                        <div className="d-flex d-none1 justify-content-between text-danger">
                                                          <div>
                                                            <small className="fw-bold">
                                                              {
                                                                swapErr.toErrText
                                                              }
                                                            </small>
                                                          </div>
                                                          <div>
                                                            <small className="fw-bold">
                                                              {
                                                                swapErr.toErrAmount
                                                              }
                                                            </small>
                                                          </div>
                                                        </div>
                                                        <div className="inputField border p-3 mb-4 pb-0">
                                                          <Form.Group
                                                            className="mb-3"
                                                            controlId="formBasicEmail"
                                                          >
                                                            <div className="d-flex justify-content-between">
                                                              <div>
                                                                <Form.Label>
                                                                  Receive
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  placeholder="0"
                                                                  className="fs-3 border-0 bg-transparent p-0"
                                                                  name="toAmount"
                                                                  // onKeyPress={(
                                                                  //   event
                                                                  // ) => {
                                                                  //   if (
                                                                  //     !/^\d*[.]?\d{0,1}$/.test(
                                                                  //       event.key
                                                                  //     )
                                                                  //   ) {
                                                                  //     event.preventDefault();
                                                                  //   }
                                                                  // }}
                                                                  onKeyPress={(
                                                                    event
                                                                  ) => {
                                                                    // Allow only digits, backspace, and decimal point
                                                                    if (
                                                                      !/^\d$/.test(
                                                                        event.key
                                                                      ) &&
                                                                      event.key !==
                                                                      "." &&
                                                                      event.key !==
                                                                      "Backspace"
                                                                    ) {
                                                                      event.preventDefault();
                                                                    }

                                                                    // Prevent entering more than four digits after the decimal point
                                                                    const {
                                                                      value,
                                                                    } =
                                                                      event.target;
                                                                    const decimalIndex =
                                                                      value.indexOf(
                                                                        "."
                                                                      );
                                                                    if (
                                                                      decimalIndex !==
                                                                      -1 &&
                                                                      value.slice(
                                                                        decimalIndex +
                                                                        1
                                                                      )
                                                                        .length >=
                                                                      4 &&
                                                                      event.key !==
                                                                      "Backspace"
                                                                    ) {
                                                                      event.preventDefault();
                                                                    }

                                                                    // Ensure only one decimal point is allowed
                                                                    if (
                                                                      event.key ===
                                                                      "." &&
                                                                      value.indexOf(
                                                                        "."
                                                                      ) !== -1
                                                                    ) {
                                                                      event.preventDefault();
                                                                    }
                                                                  }}
                                                                  value={
                                                                    amountToReceive
                                                                  }
                                                                  onInput={(
                                                                    e
                                                                  ) =>
                                                                    inputHandler(
                                                                      e
                                                                    )
                                                                  }
                                                                  autoComplete="off"
                                                                />
                                                              </div>
                                                              <div>
                                                                <Form.Label>
                                                                  Balance:{" "}
                                                                  {parseFloat(
                                                                    tokenB.balance ||
                                                                    0
                                                                  ).toFixed(2)}
                                                                </Form.Label>
                                                                <div>
                                                                  <Button
                                                                    variant="default"
                                                                    className="text-primary border-0 bg-transparent fs-5 text-uppercase currency_dropdown"
                                                                    style={{
                                                                      lineHeight:
                                                                        "0",
                                                                    }}
                                                                  >
                                                                    <img
                                                                      src={
                                                                        tokenB.icon
                                                                      }
                                                                      width="35px"
                                                                    />
                                                                    &nbsp;{" "}
                                                                    {
                                                                      tokenB.symbol
                                                                    }
                                                                    {/* <LiaAngleDownSolid /> */}
                                                                  </Button>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="d-none">
                                                              <small>
                                                                $172,464.59{" "}
                                                                <span className="text-danger">
                                                                  <b>
                                                                    (-8.920%)
                                                                  </b>
                                                                </span>
                                                              </small>
                                                            </div>
                                                          </Form.Group>
                                                        </div>
                                                        {walletConnnected &&
                                                          amountToSwap > 0 && (
                                                            <>
                                                              <div className="d-flex justify-content-between my-4 align-items-center">
                                                                <div>
                                                                  <h5 className="mb-0 text-primary">
                                                                    1{" "}
                                                                    {
                                                                      tokenA.symbol
                                                                    }{" "}
                                                                    ≈{" "}
                                                                    {PriceLoading ? (
                                                                      <ClipLoader
                                                                        size={
                                                                          12
                                                                        }
                                                                        color="#36d7b7"
                                                                      />
                                                                    ) : (
                                                                      priceIs
                                                                    )}{" "}
                                                                    {
                                                                      tokenB.symbol
                                                                    }
                                                                  </h5>
                                                                </div>
                                                                <div>
                                                                  {tokenA.symbol ==
                                                                    "INFI" && (
                                                                      <>
                                                                        <Form>
                                                                          <Form.Check // prettier-ignore
                                                                            type="switch"
                                                                            id="custom-switch"
                                                                            label="Burn"
                                                                            onChange={
                                                                              handleIsBurn
                                                                            }
                                                                            checked={isBurn.current}
                                                                          />
                                                                        </Form>
                                                                      </>
                                                                    )}
                                                                  {/* <Dropdown>
																				<Dropdown.Toggle variant="default" id="dropdown-basic" className='bg-transparent fs-5 border-0 p-0'>
																					<BsFuelPump />&nbsp;$9.80
																				</Dropdown.Toggle>

																				<Dropdown.Menu>
																					<Dropdown.Item href="#/action-1">Action</Dropdown.Item>
																					<Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
																					<Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
																				</Dropdown.Menu>
																			</Dropdown> */}
                                                                </div>
                                                              </div>
                                                              <hr />
                                                              <div>
                                                                <div className="d-flex justify-content-between my-2 align-items-center">
                                                                  <div>
                                                                    <p className="mb-0 text-primary">
                                                                      Price
                                                                      impact
                                                                    </p>
                                                                  </div>
                                                                  <div>
                                                                    {swapSummary.priceImpact >=
                                                                      15 ? (
                                                                      <h5 className="mb-0 text-danger fw-bold fs-5">
                                                                        {
                                                                          swapSummary.priceImpact
                                                                        }
                                                                        %
                                                                      </h5>
                                                                    ) : (
                                                                      <h5 className="mb-0 text-green fw-bold fs-5">
                                                                        {
                                                                          swapSummary.priceImpact
                                                                        }
                                                                        %
                                                                      </h5>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between my-2 align-items-center">
                                                                  <div>
                                                                    <p className="mb-0 fs-5 text-primary">
                                                                      Estimated
                                                                      Fee{" "}
                                                                    </p>
                                                                  </div>
                                                                  <div>
                                                                    <h5 className="mb-0 text-primary">
                                                                      {
                                                                        FEE_SYMBOL
                                                                      }{" "}
                                                                      {
                                                                        swapSummary.fees
                                                                      }{" "}
                                                                    </h5>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="d-flex  d-none justify-content-between my-4 align-items-center">
                                                                <div>
                                                                  <p className="mb-0 ">
                                                                    Order
                                                                    Routing
                                                                  </p>
                                                                </div>
                                                                <div>
                                                                  <h5 className="mb-0">
                                                                    Uniswap API
                                                                  </h5>
                                                                </div>
                                                              </div>
                                                              <br />
                                                            </>
                                                          )}

                                                        {!swapErr.fromErrText &&
                                                          amountToSwap &&
                                                          !swapErr.toErrText &&
                                                          amountToReceive ? (
                                                          <>
                                                            {swapLoading ? (
                                                              <Button
                                                                variant="primary"
                                                                className="w-100 fs-5 d-flex justify-content-center align-items-center"
                                                                disabled
                                                              >
                                                                <ClipLoader
                                                                  size={20}
                                                                />{" "}
                                                                &nbsp;Please wait...
                                                              </Button>
                                                            ) : (
                                                              <Button
                                                                variant="primary"
                                                                className="w-100 fw-bold fs-5"
                                                                onClick={
                                                                  swapNow
                                                                }
                                                              >
                                                                Swap
                                                              </Button>
                                                            )}
                                                          </>
                                                        ) : (
                                                          // <Button disabled variant='custombtn2' className='w-100 fs-5 swapDisabled'>Swap</Button>
                                                          <Button
                                                            variant="custombtn2"
                                                            disabled
                                                            className="w-100 fs-5  swapDisabled"
                                                          >
                                                            Swap
                                                          </Button>
                                                        )}
                                                      </>
                                                    ) : (
                                                      <>
                                                        <p>
                                                          <h4 className="text-primary">
                                                            Please connect your
                                                            wallet before swap
                                                          </h4>
                                                        </p>
                                                        <Button
                                                          variant="primary"
                                                          className="w-100 fs-5 fw-bold text-light"
                                                          onClick={() =>
                                                            setConnectWalletNow(
                                                              true
                                                            )
                                                          }
                                                        >
                                                          Connect Wallet
                                                        </Button>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <Button
                                                    variant="primary"
                                                    className="w-100 fs-5"
                                                    onClick={goToLogin}
                                                  >
                                                    Login to swap
                                                  </Button>
                                                )}
                                              </Form>
                                            </Tab.Pane>
                                            {/* <Tab.Pane eventKey="buy">Buy</Tab.Pane> */}
                                          </Tab.Content>
                                        </Col>
                                      </Row>
                                    </Tab.Container>
                                  </Col>
                                </Row>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="buy"
                                role="tabpanel"
                                aria-labelledby="buy-tab"
                              >
                                <p className="text-dark">two</p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="features pt-5 pb-5">
                  <Row className="justify-content-center">
                    <Col lg={4} md={6} xs={12} className=" mb-3">
                      <div className="protocolbox">
                        <div>
                          <img
                            src="assets/icons/protocalIcon1.svg"
                            alt="protocalIcon1"
                            className="protocalIconImg ms-0 mb-10"
                          />
                        </div>
                        <div className="ptotocaltext">
                          <p className="mb-0">SbSe Protocol</p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={6} xs={12} className=" mb-3">
                      <div className="protocolbox">
                        <div>
                          <img
                            src="assets/icons/multiswapIcon.svg"
                            alt="multiswapIcon"
                            className="protocalIconImg ms-0 mb-10"
                          />
                        </div>
                        <div className="ptotocaltext">
                          <p className="mb-0">Multi-Swap Option</p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={6} xs={12} className=" mb-3">
                      <div className="protocolbox">
                        <div>
                          <img
                            src="assets/icons/swapIcon.svg"
                            alt="swapIcon"
                            className="protocalIconImg ms-0 mb-10"
                          />
                        </div>
                        <div className="ptotocaltext">
                          <p className="mb-0">One-Click Swapping</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row className="d-none">
              <Col lg={12} md={12} sm={12} className="">
                <div className="faq pt-5 pb-5">
                  <Row className="justify-content-center">
                    <Col lg={5} className="">
                      <div className="">
                        <img
                          src="assets/images/faqImg.png"
                          alt="faqImg"
                          className="faqImg"
                        />
                      </div>
                    </Col>
                    <Col lg={7} className="faq-textbox">
                      <div className="mb-2">
                        <h1 className="text-primary">FAQ</h1>
                      </div>
                      <div className="accordion-faq">
                        <AccordionBox />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/* <Footer bg="bg-primary" /> */}
            {/* <Footer /> */}
            {/* <Row>
							<Col lg={12} md={12} sm={12} className="">
								<Dashboardfooter />
							</Col>
						</Row> */}
          </Container>
        </div>
      </div>
      </div>
      {/* ---------- */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="text-center">
              <h3>Select a token</h3>
            </div>
            <InputGroup className="mb-3 mt-3">
              <InputGroup.Text
                id="basic-addon1"
                className="bg-transparent border-0 searchbtn"
              >
                <IoSearch />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search by name or address"
                aria-label="Search by name or address"
                aria-describedby="basic-addon1"
                style={inputstyle}
              />
            </InputGroup>
            <div>
              <Button
                variant="outline-secondary"
                className="text-white fs-6 me-2 mb-2"
              >
                <img src="assets/images/coin/eth.svg" width="35px" />
                &nbsp;&nbsp;<b>ETH </b>
              </Button>
              <Button
                variant="outline-secondary"
                className="text-white fs-6 me-2 mb-2"
              >
                <img src="assets/images/coin/usdt.svg" width="35px" />
                &nbsp;&nbsp;<b>USDT </b>
              </Button>
              <Button
                variant="outline-secondary"
                className="text-white fs-6 me-2 mb-2"
              >
                <img src="assets/images/coin/dai.svg" width="35px" />
                &nbsp;&nbsp;<b>DAI </b>
              </Button>
              <Button
                variant="outline-secondary"
                className="text-white fs-6 me-2 mb-2"
              >
                <img src="assets/images/coin/usdc.svg" width="35px" />
                &nbsp;&nbsp;<b>USDC </b>
              </Button>
              <Button
                variant="outline-secondary"
                className="text-white fs-6 me-2 mb-2"
              >
                <img src="assets/images/coin/wbtc.svg" width="35px" />
                &nbsp;&nbsp;<b>WBTC </b>
              </Button>
              <Button
                variant="outline-secondary"
                className="text-white fs-6 me-2 mb-2"
              >
                <img src="assets/images/coin/wbtc.svg" width="35px" />
                &nbsp;&nbsp;<b>WBTC </b>
              </Button>
            </div>
            <hr />
            <div className="list">
              <ul className="list-unstyled pl-0">
                <li className="py-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="me-2">
                        <img
                          src="assets/images/coin/oxbitcoin.svg"
                          width="50px"
                        />
                      </div>
                      <div>
                        <p className="mb-0">0xBitcoin Token</p>
                        <small>0xbtc</small>
                      </div>
                    </div>
                    <div>
                      <span className="me-2">$0</span>{" "}
                      <img
                        src="assets/images/icon/thumbtack.svg"
                        width="15px"
                      />
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="me-2">
                        <img
                          src="assets/images/coin/oxbitcoin.svg"
                          width="50px"
                        />
                      </div>
                      <div>
                        <p className="mb-0">0xBitcoin Token</p>
                        <small>0xbtc</small>
                      </div>
                    </div>
                    <div>
                      <span className="me-2">$0</span>{" "}
                      <img
                        src="assets/images/icon/thumbtack.svg"
                        width="15px"
                      />
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="me-2">
                        <img
                          src="assets/images/coin/oxbitcoin.svg"
                          width="50px"
                        />
                      </div>
                      <div>
                        <p className="mb-0">0xBitcoin Token</p>
                        <small>0xbtc</small>
                      </div>
                    </div>
                    <div>
                      <span className="me-2">$0</span>{" "}
                      <img
                        src="assets/images/icon/thumbtack.svg"
                        width="15px"
                      />
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="me-2">
                        <img
                          src="assets/images/coin/oxbitcoin.svg"
                          width="50px"
                        />
                      </div>
                      <div>
                        <p className="mb-0">0xBitcoin Token</p>
                        <small>0xbtc</small>
                      </div>
                    </div>
                    <div>
                      <span className="me-2">$0</span>{" "}
                      <img
                        src="assets/images/icon/thumbtack.svg"
                        width="15px"
                      />
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="me-2">
                        <img
                          src="assets/images/coin/oxbitcoin.svg"
                          width="50px"
                        />
                      </div>
                      <div>
                        <p className="mb-0">0xBitcoin Token</p>
                        <small>0xbtc</small>
                      </div>
                    </div>
                    <div>
                      <span className="me-2">$0</span>{" "}
                      <img
                        src="assets/images/icon/thumbtack.svg"
                        width="15px"
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* -------------- */}
    </>
  );
};

export default Swap;
